export default {
  'prefer.cc.apply': {
    ko: '변경 색상 적용',
    ja: '変更カラーを適用',
    en: 'Apply updated color',
    cn: '',
  },
  'prefer.cc.apply.default': {
    ko: '디폴트 색상 적용',
    ja: 'デフォルトカラーを適用',
    en: 'Apply default color',
    cn: '',
  },
  'prefer.cc.rspn.section.set': {
    ko: '응답시간 구간 설정',
    ja: '応答時間の区間を設定',
    en: 'Set R.T. sections',
    cn: '',
  },
  'prefer.cc.title.equalizer': {
    ko: 'Equalizer/OWLView',
    ja: 'イコライザー/OWLView',
    en: 'Equalizer/OWLView',
    cn: '',
  },
  'prefer.cc.info.max.rspn': {
    ko: '응답시간 구간 값은 10,000보다 클 수 없습니다.',
    ja: '応答時間の間隔値は10,000を超えることはできません。',
    en: 'Maximum value is 10,000.',
    cn: '',
  },
  'prefer.cc.title.user.type': {
    ko: 'User > Type',
    ja: 'ユーザー>タイプ',
    en: 'User > Type',
    cn: '',
  },
  'prefer.cc.minus.rspn': {
    ko: '100 ms 빼기',
    ja: '-100ms',
    en: 'Minus 100 ms',
    cn: '',
  },
  'prefer.cc.title.wp.status': {
    ko: 'Workprocess > Status',
    ja: 'ワークプロセス>ステータス',
    en: 'Workprocess > Status',
    cn: '',
  },
  'prefer.cc.section': {
    ko: '구간',
    ja: '区間',
    en: 'Section',
    cn: '',
  },
  'prefer.cc.apply.default.confirm': {
    ko: '디폴트 색상을 적용하시겠습니까?',
    ja: 'デフォルトのカラーを適用しますか？',
    en: 'Will you apply default color?',
    cn: '',
  },
  'prefer.cc.title.wp.type': {
    ko: 'Workprocess > Type',
    ja: 'ワークプロセス>タイプ',
    en: 'Workprocess > Type',
    cn: '',
  },
  'prefer.cc.info.min.rspn': {
    ko: '응답시간 구간 값은 100보다 작을 수 없습니다.',
    ja: '応答時間の間隔値は100未満にできません。',
    en: 'Minimum value is 100.',
    cn: '',
  },
  'prefer.cc.info.than.lower': {
    ko: '값이 하위 구간보다 적거나 같을 수 없습니다.',
    ja: '値の下位区間より小さいか同じにできません。',
    en: 'The value is not able be smaller than or same with lower section.',
    cn: '',
  },
  'prefer.cc.info.than.upper': {
    ko: '값이 상위 구간보다 크거나 같을 수 없습니다.',
    ja: '値が上位区間より大きいか同じにできません。',
    en: 'The value is not able be bigger than or same with upper section.',
    cn: '',
  },
  'prefer.cc.apply.confirm': {
    ko: '변경된 색상을 적용하시겠습니까?',
    ja: '更新されたカラーを適用しますか？',
    en: 'Will you apply updated color?',
    cn: '',
  },
  'prefer.cc.plus.rspn': {
    ko: '100 ms 더하기',
    ja: '+100ms',
    en: 'Plus 100 ms',
    cn: '',
  },
  'prefer.cc.select.color': {
    ko: '색상 선택',
    ja: 'カラー選択',
    en: 'Selecting color',
    cn: '',
  },
};
